import { RUM_RELEASE } from './constants'

import { getRouteGroup } from './route-group'
import type { RumContext } from './types'

interface NetworkInformation {
    effectiveType?: string
    saveData?: boolean
}

interface NavigatorWithNetwork extends Navigator {
    connection?: NetworkInformation
    deviceMemory?: number
}

interface WindowWithDeviceFlags extends Window {
    isMobile?: boolean
}

function getNetworkInformation(): NetworkInformation | undefined {
    return (navigator as NavigatorWithNetwork).connection
}

function getDeviceType(): RumContext['deviceType'] {
    return (window as WindowWithDeviceFlags).isMobile ? 'mobile' : 'desktop'
}

export function buildContext(entryRoute: string, sampleRate: number): RumContext {
    const network = getNetworkInformation()
    const navigatorWithNetwork = navigator as NavigatorWithNetwork

    return {
        entryRoute,
        entryRouteGroup: getRouteGroup(entryRoute),
        deviceType: getDeviceType(),
        connection: network?.effectiveType,
        saveData: network?.saveData,
        deviceMemory: navigatorWithNetwork.deviceMemory,
        hardwareConcurrency: navigator.hardwareConcurrency,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight,
        release: RUM_RELEASE,
        sampleRate,
    }
}
